// extracted by mini-css-extract-plugin
export default {"toggle-switch":"ToggleSwitch_toggle-switch__U8hw+","on":"ToggleSwitch_on__I9J7h","toggle-switch-knob":"ToggleSwitch_toggle-switch-knob__IepG9","off":"ToggleSwitch_off__NsaOw"};